/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import Loader from "../../elements/Loader";
import {
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import ShowLess from "../../partials/ShowLess";
import styles from "./tutorial.module.scss";

const tutorials = [
  {
    label: "nuScenes",
    slug: "nuscenes",
    file: "nuscenes_tutorial.html",
  },
  {
    label: "nuScenes-lidarseg and panoptic",
    slug: "lidarseg_panoptic",
    file: "nuscenes_lidarseg_panoptic_tutorial.html",
  },
  {
    label: "Maps",
    slug: "maps",
    file: "map_expansion_tutorial.html",
  },
  {
    label: "Prediction",
    slug: "prediction",
    file: "prediction_tutorial.html",
  },
  {
    label: "CAN bus",
    slug: "can-bus",
    file: "can_bus_tutorial.html",
  },
];

class Tutorial extends React.Component<any, any> {
  iframe: HTMLIFrameElement | null = null;

  state = {
    iframeLoaded: false,
  };

  componentDidMount() {
    window.addEventListener("resize", this.onFrameLoad);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onFrameLoad);
  }

  onFrameLoad = () => {
    if (this.iframe && this.iframe.contentWindow) {
      this.setState({
        iframeLoaded: true,
      });
      try {
        this.iframe.contentWindow.document.body.style.position = "static";
        this.iframe.style.height =
          this.iframe.contentWindow.document.body.scrollHeight + "px";
        // make all links open in a new tab rather than just in the iframe
        // except anchor links
        Array.from<HTMLAnchorElement>(
          this.iframe.contentWindow.document.body.getElementsByTagName("a")
        )
          .filter((a) => !a.classList.contains("anchor-link"))
          .forEach((element) => {
            element.target = "_blank";
            element.rel = "noopener";
          });
      } catch (e) {}
    }
  };

  onChangeTutorial = (e) => {
    this.props.onTutorialChange(e.target.value);
  };

  render() {
    const { slug } = this.props;
    const tutorial = tutorials.find((t) => t.slug === slug);

    return (
      <ShowLess className="relative">
        <div className="content text-justify">
          <p>
            We provide a number of tutorials for nuScenes as interactive Jupyter
            Notebooks in the{" "}
            <a
              href="https://github.com/nutonomy/nuscenes-devkit/tree/master/python-sdk/tutorials"
              target="_blank"
              rel="noreferrer"
            >
              devkit
            </a>
            . The tutorials are shown here as static pages for users that do not
            want to download the dataset. These tutorials cover the basic usage
            of nuScenes, nuScenes-lidarseg, the map and CAN bus expansions, as
            well as the prediction challenge. Use the dropdown menu below to
            select the tutorial you want to view.
            <br />
            Alternatively, you can run the tutorials interactively on
            Colab:&nbsp;&nbsp;
            <a
              href="https://colab.research.google.com/github/nutonomy/nuscenes-devkit/"
              style={{ verticalAlign: "middle" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://colab.research.google.com/assets/colab-badge.svg"
                alt="Open In Colab"
              />
            </a>
          </p>
        </div>

        <div className={`content ${styles.content}`}>
          <FormControl>
            <InputLabel htmlFor="scenes">Select tutorial</InputLabel>
            <Select
              value={tutorial ? tutorial.slug : ""}
              onChange={this.onChangeTutorial}
              inputProps={{
                name: "tutorials",
                id: "tutorials-options",
              }}
              className={styles.select}
            >
              <MenuItem value="" selected={slug === ""}>
                Select tutorial ...
              </MenuItem>
              {tutorials.map((option, index) => (
                <MenuItem
                  value={option.slug}
                  key={index}
                  selected={tutorial && tutorial.slug === slug}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {tutorial ? (
          <Container>
            <Loader isOpen={!this.state.iframeLoaded} />
            <iframe
              loading="lazy"
              className={styles.iframe}
              src={`/tutorials/${tutorial.file}`}
              onLoad={this.onFrameLoad}
              ref={(input) => (this.iframe = input)}
            />
          </Container>
        ) : (
          <div className={styles.blank} />
        )}
      </ShowLess>
    );
  }
}

export default Tutorial;
